<script>
import { approval_options } from '../../utils/config';

export default {
    props: {
        approval_status: {
            type: Object,
            required: true
        }
    },

    computed: {
        default_option() {
            return { key: 'pending', bgColor: 'gray', icon: 'fa-solid fa-check' };
        },

        approval_option() {
            if (!this.approval_status || !this.approval_status.status) 
                return this.default_option;

            const o = approval_options.find(x => x.key === this.approval_status.status);
            if (!o) {
                console.log(`Option could not be found for the following item: ${JSON.stringify(this.approval_status)}`);
                return this.default_option;
            }

            return o;
        },
    },
}
</script>

<template>
    <i  
      :class="approval_option.icon" 
      :style="{ 'color': approval_option.bgColor }"
      v-sust-tooltip="{
        text: $t(`approval.options.${approval_option.key}`),
        fontSize: '.8em'
      }"
    ></i>
</template>

<style lang='scss' scoped>

</style>